import React, {Fragment} from "react";
import {HalfNHalfArticle, MenuItem} from "../../@types/stores/menu";
import {useTranslation} from "react-i18next";
import menuStore from "../../stores/menu";
import { v4 as guid } from 'uuid';
import {
    getAllergenById, getCurrency,
    getHost,
    getPreferenceById
} from "../../helpers/ApiHelper";
import {LazyLoadImage} from "react-lazy-load-image-component";
import defaultImg from "../../assets/images/default.webp";
import useLayoutStyles from "../../hooks/styles";
import "./style.scss";
import {ReactComponent as IconCheck} from "../../assets/icons/check.svg";
import {useNavigate} from "react-router";
import {moveToTop} from "../../helpers/DomHelper";


export interface HalfAndHalfArticlesGroupProps {
    step: number;
    articles: HalfNHalfArticle[];
    selected: MenuItem | null;
    onSelect: (step: number, isSelected: boolean, item: MenuItem) => void;
}

const HalfAndHalfArticlesGroup = ({step, articles, selected, onSelect}: HalfAndHalfArticlesGroupProps) => {
    const [t] = useTranslation();
    const navigate = useNavigate();

    const select = (isSelected: boolean, item: HalfNHalfArticle) => {
        onSelect(step, isSelected, item.article);

        if (isSelected && (item.article.modifierGroups || item.article.addonGroups || item.article.ingredientGroups)) {
            menuStore.selectedHalfAndHalfStep = step;

            if (!menuStore.selectedAdditionalSellUnitHalfAndHalf && item.article.additionalSellUnits?.length) {
                moveToTop();
                navigate(`/menu/halfAndHalf/${item.categoryId}/${item.subCategoryId}/${item.article.number}/additionalSellUnits`);
                return;
            }
            else if (item.article.modifierGroups?.length) {
                moveToTop();
                navigate(`/menu/halfAndHalf/${item.categoryId}/${item.subCategoryId}/${item.article.number}/modifiers`);
                return;
            }
            else if (item.article.addonGroups?.length) {
                moveToTop();
                navigate(`/menu/halfAndHalf/${item.categoryId}/${item.subCategoryId}/${item.article.number}/addons`);
                return;
            }
            else if (item.article.ingredientGroups?.length) {
                moveToTop();
                navigate(`/menu/halfAndHalf/${item.categoryId}/${item.subCategoryId}/${item.article.number}/ingredients`);
                return;
            }
        }

        menuStore.selectedHalfAndHalfItems[step] = {
            id: guid(),
            articleId: item.article.id,
            menuId: item.categoryId,
            subMenuId: item.subCategoryId,
            name: item.article.name,
            number: item.article.number,
            count: 0.5,
            price: item.article.price,
            total: item.article.price,
            img: item.article.previewList,
            sellUnitId: menuStore.selectedAdditionalSellUnitHalfAndHalf?.sellUnitId || undefined,
            sellFactor: menuStore.selectedAdditionalSellUnitHalfAndHalf?.sellFactor || undefined
        };
    }

    return <div className="ArticleGroup articleGroup">
        <div className={`groupHeader`}>
            <div className="groupTitle">
                <div>
                    <div className="step">{t(step === 0 ? "halfNHalf.stepTitle.0" : "halfNHalf.stepTitle.1")}</div>
                </div>
            </div>
        </div>
        <div className="items">
            {articles.map(x => <Fragment key={`hahArticle_${step}_${x.categoryId}_${x.subCategoryId}_${x.article.number}`}>
                <ArticleGroupItem
                    item={x.article}
                    checked={selected?.number === x.article.number}
                    onChange={(selected: boolean) => select(selected, x)}
                />
            </Fragment>
            )}
        </div>
    </div>
}

export interface ArticleGroupItemProps {
    item: MenuItem;
    checked: boolean;
    onChange: (selected: boolean) => void;
}

const ArticleGroupItem = ({item, checked, onChange}: ArticleGroupItemProps) => {
    const styles = useLayoutStyles();

    return <div className="ArticleGroupItem articleGroupItem">
        <div key={`menuItem_${item.name}`} className="item" onClick={() => onChange(!checked)}>
            <div className="tagsImages">
                {item.allergens?.filter(y => menuStore.filter.allergens.indexOf(y) !== -1).map(y => getAllergenById(y)?.image ?
                    <img key={`allergenTagImage_${y}`}
                         src={`${getHost()}${getAllergenById(y)?.image || ""}`}
                         alt={getAllergenById(y)?.name}/> : null)}
                {item.preferences?.filter(y => menuStore.filter.preferences.indexOf(y) !== -1).map(y => getPreferenceById(y)?.image ?
                    <img key={`preferenceTagImage_${y}`}
                         src={`${getHost()}${getPreferenceById(y)?.image || ""}`}
                         alt={getPreferenceById(y)?.name}/> : null)}
            </div>
            <div
                className={`img ${item.allergens?.filter(y => menuStore.filter.allergens.indexOf(y) !== -1).length ? "blur" : ""}`}>
                <LazyLoadImage alt={item.name}
                               src={item.previewList ? `${getHost()}${item.previewList}` : (styles?.article.defaultListImage ? `${getHost()}${styles.article.defaultListImage}` : defaultImg)}
                               effect="blur"/>
            </div>
            <div className="text">
                <div className="tagContainer">
                    <div className="tags">
                        {item.allergens?.filter(y => menuStore.filter.allergens.indexOf(y) !== -1).map(y => getAllergenById(y) ?
                            <div key={`allergenTag_${y}`}
                                 className="tag allergen">{getAllergenById(y)?.name || ""}</div> : null)}
                        {item.preferences?.filter(y => menuStore.filter.preferences.indexOf(y) !== -1).map(y => getPreferenceById(y) ?
                            <div key={`preferenceTag_${y}`}
                                 className="tag preference">{getPreferenceById(y)?.name || ""}</div> : null)}
                    </div>
                </div>
                <div className="title">
                    {item.name}
                </div>
                <div className="price">
                    {item.price.toFixed(2)} {getCurrency()}
                </div>
                {checked
                    ? <div className="check">
                        <IconCheck />
                    </div>
                    : null
                }
            </div>
        </div>
    </div>
}

export default HalfAndHalfArticlesGroup;
